import UserCustomColumns from './userCustomColumns';
import MassSelect from './massSelect';
import InlineEditors from './inlineEditors';
import Filter from './filter';
import ProjectCalendar from './projectCalendar';
import Tasks from './tasks';
import CopyPaste from './copyPaste';
import Costs from './costs';
import Links from './links';
import Estimation from './estimation';

class Controllers {
  init(instance) {
    UserCustomColumns.init(instance);
    MassSelect.init(instance);
    InlineEditors.init(instance);
    Filter.init(instance);
    ProjectCalendar.init(instance);
    Tasks.init(instance);
    CopyPaste.init(instance);
    Costs.init(instance);
    Estimation.init(instance);
    Links.init(instance);
  }

  initForExport(instance) {
    UserCustomColumns.init(instance);
    InlineEditors.init(instance);
    Filter.init(instance);
    ProjectCalendar.init(instance);
    Tasks.init(instance);
    Costs.init(instance);
    Estimation.init(instance);
    Links.init(instance);
  }

  initForArchived(instance) {
    UserCustomColumns.init(instance);
    InlineEditors.init(instance);
    Filter.init(instance);
    ProjectCalendar.init(instance);
    Tasks.init(instance);
    Costs.init(instance);
    Estimation.init(instance);
    Links.init(instance);
  }
}

export default new Controllers();
